export interface InhabitantDemographicsModel{
    shareOfTotal: number;
    phaseOfLifeHeader: string;
    phaseOfLifeDetail: string;
    numPersons?: number;
    medianAgeNow?: number;
    averageIncome?: number;
    shouldShow: boolean;
}

export interface DemographicAreaData {
    queryLimitReached: QueryLimit;
    numEstates: number;
    isMixedEstates: boolean;
    isOnlyVacationHomes: boolean;
    ownerAge: StatisticPanel;
    buyerAge: StatisticPanel;

    ownedPeriodNow: StatisticPanel;
    ownedPeriodPrev: StatisticPanel;
    ownerNotOnAddressShare: number;
    firstTimeBuyersShare: number;
    singleOwnerShare: number;

    ownerNotOnAddressShareNum: number;
    firstTimeBuyersShareNum: number;
    singleOwnerShareNum: number;

    estateTypeChangesDetached: number[];
    estateTypeChangesSemiDetached: number[];
    estateTypeChangesRowhouse: number[];
    estateTypeChangesFlat: number[];

    estateTypeChangesDetachedNum: number[];
    estateTypeChangesSemiDetachedNum: number[];
    estateTypeChangesRowhouseNum: number[];
    estateTypeChangesFlatNum: number[];

    movedWithinCountyShare: number;
    movedWithinCountyNum: number;
    movedWithinCouncilShare: number;
    movedWithinCouncilNum: number;
    movedWithinCityDistrictShare: number;
    movedWithinCityDistrictNum: number;
    movedWithinSubcouncilShare: number;
    movedWithinSubcouncilNum: number;
    movedWithinShare: number;
    movedWithinNum: number;

    buyersOrigin: string;

    debugSql: string;
}

export enum QueryLimit {
    WithinLimit = 0,
    LimitReached = 1
}

export interface StatisticPanel {
    headerTxt?: string;
    subTxt?: string;
    total?: number;
    average?: number;
    median?: number;
    ranges?: Range[];
    tooltip?: Tooltip;
    showWarning?: boolean;
    warningTooltip?: Tooltip;
    includesBRL?: boolean;
}

export class Range {
    lowBound: string;
    upperBound: string;
    value: number;
}

interface Tooltip {
    show: boolean;
    header: string;
    info: string[];
}
